import { PageStatus } from '@adornis/buildify/db/enums';

export function transformStatus(status: PageStatus) {
  switch (status) {
    case PageStatus.IN_PROGRESS:
      return 'In Arbeit';
    case PageStatus.PUBLISHED:
      return 'Veröffentlicht';
  }
}
